/**
 * Copyright (c) 2017 CA. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */

// @flow

import { compose } from 'recompose';
import { connect } from 'react-redux';

import ErrorRateChart from '../../../../../components/Analytics/CannedCharts/HLECharts/ErrorRateChart';
import {
  fetchMetricsData,
} from '../../../../../actions/metrics';
import {
  CHART_HLE_ERROR_RATE,
  HISTORICAL_METRIC_30DAYS,
  HISTORICAL_METRIC_52WEEKS,
} from '../../../../../constants/charts';
import { API_BASED } from '../../../../../constants/metrics';
import {
  getChartData,
  getApiMap,
  getAppMap,
  getOrgMap,
  getIsChartLoading,
  getIsMetricTypeDataLoading,
 } from '../../../../../reducers/metrics';

const defaultParams = {
  sortOrder: 'desc',
  sortBy: 'date',
  limit: [3],
  stats: ['errorRate'],
  timerange: 'week',
  buckets: ['apis'],
};

const metric = 'errors';

export const mapDispatchToProps = (dispatch) => ({
  fetchMetricsData: () =>
    dispatch(
      fetchMetricsData(
        CHART_HLE_ERROR_RATE,
        defaultParams,
        metric,
        'by-day',
        API_BASED,
      ),
    ),
  fetchCustomDateMetricsData: (params) =>
    dispatch(
      fetchMetricsData(
        CHART_HLE_ERROR_RATE,
        params,
        metric,
        params.aggregation,
        API_BASED,
      ),
    ),
});

export const mapStateToProps = (state) => ({
  defaultErrorsResponse: getChartData(state, CHART_HLE_ERROR_RATE),
  apiMap: getApiMap(state),
  appMap: getAppMap(state),
  orgMap: getOrgMap(state),
  errorsResponseFor30DaysAgo:
    getChartData(
      state,
      CHART_HLE_ERROR_RATE,
      HISTORICAL_METRIC_30DAYS,
    ),
  errorsResponseFor52WeeksAgo:
    getChartData(
      state,
      CHART_HLE_ERROR_RATE,
      HISTORICAL_METRIC_52WEEKS,
    ),
  isLoading: getIsChartLoading(state, CHART_HLE_ERROR_RATE),
  is30DaysDataLoading: getIsMetricTypeDataLoading(
    state,
    CHART_HLE_ERROR_RATE,
    HISTORICAL_METRIC_30DAYS,
  ),
  is52WeeksDataLoading: getIsMetricTypeDataLoading(
    state,
    CHART_HLE_ERROR_RATE,
    HISTORICAL_METRIC_52WEEKS,
  ),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
)(ErrorRateChart);
